import notifications from './notifications';

(function addBidListLogic() {
  const pleaseHideMe = document.querySelector('.pleaseHideMe');
  const bidsData = document.getElementById('js-data-bids');
  const { bidError } = bidsData.dataset;
  const { bidSuccess } = bidsData.dataset;
  const { bidUrl } = bidsData.dataset;
  const bidForms = document.querySelectorAll('form.bidForm');

  // Event listener functions
  function hide(event) {
    event.preventDefault();

    document.getElementsByClassName('pleaseHideMe')[0].style.visibility = 'hidden';
  }

  function displayNotification(feedbackMessage) {
    const notification = document.getElementById('largeNotification');
    notification.innerHTML = `<div id="bid-notification">
                <h3>${feedbackMessage}</h3>
                <button type="button" class="btn btn-primary btn-lg btn-block">Ok</button>
            </div>`;

    // Undo current user selection.
    notifications.unselectAll();

    notifications.showLargeNotificationPanel();
  }

  function submitBidForm(event) {
    event.preventDefault();
    const form = event.target;
    const inputField = form.bidValue;
    let feedbackMessage = bidError;

    let originalResponse;

    fetch(bidUrl, {
      method: 'POST',
      body: new FormData(form),
      headers: {
        Accept: 'application/json',
      },
    })
      .then((response) => {
        originalResponse = response;
        return response.json();
      })
      .then((data) => {
        if (originalResponse.status < 200 || originalResponse.status >= 300) {
          throw new Error(data.message);
        }

        if (data.bid) {
          // Change input render style based on bid result.
          inputField.classList.toggle('has-error', false);

          feedbackMessage = `${bidSuccess}<br><br>€${data.bid},-`;
          inputField.classList.remove('bg-danger');
          inputField.classList.add('bg-success');
          displayNotification(feedbackMessage);
        }
      })
      .catch((error) => {
        // feedbackMessage = error.message;
        inputField.classList.toggle('has-error', true);
        displayNotification(error.message);
      });

    return false;
  }
  // Register event listeners
  pleaseHideMe.addEventListener('click', hide);

  for (let i = 0; i < bidForms.length; i += 1) {
    bidForms[i].addEventListener('submit', submitBidForm);
  }
}());
